import { render, staticRenderFns } from "./activitypackagecomment.vue?vue&type=template&id=d8f0495e&"
import script from "./activitypackagecomment.vue?vue&type=script&lang=js&"
export * from "./activitypackagecomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports